import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_LARGE, FONT_SIZE_MEDIUM, FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import {
  GRAY_DARK_SHADE_2,
  PRIMARY_BLUE,
  WHITE,
  LIGHT_GRAY,
  VERTICAL_SEPARATOR,
  BORDER_COLOR_SHADE_2,
} from '~/Constants/Colors.constants';

export const MonthSelectorStyles = makeStyles((theme) => ({
  monthViewContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: 25,
    fontFamily: 'fitogram, sans-serif',
    fontWeight: 'bold',
    background: WHITE,
    [theme.breakpoints.down('md')]: {
      marginTop: '2rem',
      borderTop: `1px solid ${VERTICAL_SEPARATOR}`,
      borderBottom: `1px solid ${VERTICAL_SEPARATOR}`,
    },
    rowGap: 13,
  },
  monthViewWrapper: {
    height: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    justifyContent: 'space-between',
    alignItems: 'center',
    rowGap: 8,
    fontSize: FONT_SIZE_SMALLISH,
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(6, 1fr)',
    },
  },
  headerControl: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    letterSpacing: 0.5,
  },
  startYear: {
    fontSize: FONT_SIZE_MEDIUM,
    [theme.breakpoints.down('md')]: {
      fontSize: FONT_SIZE_LARGE,
    },
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: 500,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      width: 'initial',
    },
  },
  controls: {
    display: 'flex',
    flexDirection: 'row',
  },
  controlsBtn: {
    width: 30,
    lineHeight: '100%',
    textAlign: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
  },
  month: {
    display: 'flex',
    flex: '25%',
    height: 37,
    margin: 0,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      background: GRAY_DARK_SHADE_2,
    },
    '&.active': {
      background: PRIMARY_BLUE,
      color: WHITE,
    },
    '&.grayedOut': {
      background: LIGHT_GRAY,
    },
    '&.currentMonth': {
      color: PRIMARY_BLUE,
    },
    '&.currentMonth.active': {
      color: WHITE,
    },
    '&.start': {
      borderTopLeftRadius: 3,
      borderBottomLeftRadius: 3,
    },
    '&.end': {
      borderTopRightRadius: 3,
      borderBottomRightRadius: 3,
    },
    '&.disabled': {
      color: BORDER_COLOR_SHADE_2,
      pointerEvents: 'none',
    },
  },
}));
